export const tracksData = {
  dashboard: 'dashboard',
  bulletins: 'boletins',
  biddings: 'encontrar licitações',
  imminence: 'licitações estratégicas',
  management: 'gerenciar licitações',
  monitoring: 'monitoramento',
  documents: 'gerenciar documentos',
  drlicita: 'drlicita',
  portals: 'gerenciar portais',
  conlicitaseg: 'conlicitaseg',
  market: 'análise de mercado',
  ata: 'ata de registro de preço',
  contracts: 'contratos',
  my_history: 'meu histórico',
  juridico: 'jurídico fácil',
};

export type TrackDataKey = keyof typeof tracksData;
